export const GET_ADMIN_REDIRECT_QUERY_KEY = ['adminRedirect'] as const;
